import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './UseCases.css';

const industries = [
  {
    title: 'Banking & Financial Services',
    path: '/use-cases/banking',
    product: 'Runtime Shield',
    description: 'Protect banking chatbots and customer support AI from prompt injection, jailbreak attacks, credential theft, and financial fraud with real-time runtime protection.',
    threats: ['Prompt Injection', 'Jailbreak', 'Credential Theft', 'Chatbot Security'],
  },
  {
    title: 'Legal Services',
    path: '/use-cases/legal',
    product: 'Purple Team',
    description: 'Increase safety scores for legal analysis and document writer AI models with continuous purple team testing — measuring and improving accuracy, bias, and compliance.',
    threats: ['Hallucinated Citations', 'Document Safety', 'Bias Detection', 'Privilege Leakage'],
  },
  {
    title: 'Medical & Healthcare',
    path: '/use-cases/medical',
    product: 'Workspace',
    description: 'Automate AI governance for PII, PHI, and sensitive health information — enforcing HIPAA compliance and tool connection governance rules across every AI system.',
    threats: ['PHI Exposure', 'PII Leakage', 'Tool Access Control', 'Compliance Gaps'],
  },
  {
    title: 'Hospitality & Travel',
    path: '/use-cases/hospitality',
    product: 'Full Platform',
    description: 'Secure guest-facing AI concierge systems, protect payment and identity data, and govern operational AI tools across hotel chains and travel platforms.',
    threats: ['Guest Data Leaks', 'Concierge Attacks', 'Price Manipulation', 'Multi-Region Compliance'],
  },
];

const UseCases = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="main-hero demo-hero">
        <div className="hero-gif-fade-left"></div>
        <div className="hero-gif-fade-right"></div>
        <h1 className="hero-page-title">Use Cases</h1>
      </section>

      <section className="uc-content">
        <div className="uc-layout">
          <h2 className="uc-heading">AI Security Across Industries</h2>
          <p className="uc-description">See how Bltz protects enterprise AI deployments across regulated industries — from runtime threat prevention to automated governance and continuous safety testing.</p>

          <div className="uc-industry-grid">
            {industries.map((ind) => (
              <div key={ind.path} className="uc-industry-card" onClick={() => { navigate(ind.path); window.scrollTo(0, 0); }}>
                <div className="uc-industry-product">{ind.product}</div>
                <h3 className="uc-industry-title">{ind.title}</h3>
                <p className="uc-industry-desc">{ind.description}</p>
                <div className="uc-industry-threats">
                  {ind.threats.map((t) => (
                    <span key={t} className="uc-industry-threat">{t}</span>
                  ))}
                </div>
                <span className="uc-industry-link">Learn More &rarr;</span>
              </div>
            ))}
          </div>

          <div className="uc-cta">
            <button className="uc-cta-btn" onClick={() => { navigate('/book-demo'); window.scrollTo(0, 0); }}>
              Get a Live Demo &rarr;
            </button>
          </div>
          <span className="uc-back-link" onClick={() => { navigate('/'); window.scrollTo(0, 0); }} style={{ cursor: 'pointer' }}>
            ← Back to Home
          </span>
        </div>
      </section>
    </>
  );
};

export default UseCases;
